import React from 'react';
import iconLoading from '../img/icon-spinner.svg';
//import iconCloseBurger from '../img/icon-closeburger.png'

//import { AppContext } from '../context/AppContext';

export default class Loading extends React.Component {

    //handleClickCloser = () => {
    //    this.context.setState({ loading: 0 });

    //}
    render() {
        //const style = { cursor: "pointer" };
        return (
            <div className="loading-component">
                <div className="loading-component-container">

                    <img src={iconLoading} alt="" />

                </div>
            </div>
        );
    }
}
//Loading.contextType = AppContext;


// WEBPACK FOOTER //
// ./src/components/Loading.js